import React, { useContext, useEffect, useState } from 'react';
import TaskFilesView from '../view/TaskFilesView';
import { FetchCallbacksContext } from '../../../internal-components/FetchCallbacks';

const TaskFilesEngine = ({ taskId, viewOnly, refreshTimeline = () => {} }) => {
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const [files, setFiles] = useState([]);

  const loadAndUpdateFiles = () => {
    fetchAPI(`/tasks/v1/eu/tasks/${taskId}/upload`).then(res => {
      let newFiles = [];
      const values = Object.values(res);
      values.forEach(one => {
        const fullFilename = decodeURIComponent(one.key);
        const indexOfLastSlash = fullFilename.lastIndexOf('/');
        let strippedFilename = fullFilename.substr(indexOfLastSlash + 1);
        const strippedFilenameLength = strippedFilename.length;
        let displayFilename = strippedFilename;
        if (strippedFilenameLength > 24) {
          displayFilename =
            strippedFilename.substr(0, 8) +
            '...' +
            strippedFilename.substr(strippedFilenameLength - 16);
        }
        const encodedFilename = encodeURIComponent(strippedFilename);
        newFiles.push({
          ...one,
          encodedFilename,
          strippedFilename,
          displayFilename
        });
      });
      setFiles(newFiles);
    });
  };

  useEffect(() => {
    loadAndUpdateFiles();
  }, []);

  const onFileDeleted = f => {
    if (f) {
      openSnackbar('success', 'snackbars.tasks.delete_file_success');
      refreshTimeline();
      loadAndUpdateFiles();
    } else {
      openSnackbar('error', 'snackbars.tasks.delete_file_failure');
    }
  };

  const viewProps = { files, taskId, onFileDeleted, viewOnly };

  return <TaskFilesView {...viewProps} />;
};

export default TaskFilesEngine;
